module.exports = __webpack_public_path__ + "static/media/elephant.f314b5d9.png";